;(function( $ ) {
	'use strict';

	$( document ).ready( function() {
		// placeholder attribute shim
//		$( 'input, textarea' ).placeholder();

		// checkbox graphic
		$( 'input[type="checkbox"]' ).bind( 'click.checked', function() {
			if ( $( this ).is( ':checked' ) ) {
				$( 'label[for="' + $( this ).attr( 'id' ) + '"]' ).addClass( 'checked' );
			}
			else {
				$( 'label[for="' + $( this ).attr( 'id' ) + '"]' ).removeClass( 'checked' );
			}
		} );

		// fancy select after click fix because Firefox
		$( document ).on( 'click', '.fancy-select', function( e ) {
			if ( !$( e.target ).is( 'select' ) ) {
				$( this ).find( 'select' ).click();
			}
		} );

		// mobile safari patches
		if ( Modernizr.touch && window.navigator && navigator.userAgent.toLowerCase().match( /iphone|ipad|ipod/i ) ) {
			$( document )
				.on( 'focus', 'input,textarea,select', function() {
					$( '.stick-me' ).addClass( 'fixfixed' );
					if ( $windowwidth < 800 ) {
						$( '.banner' ).addClass( 'fixfixed' );
					}
				} )
				.on( 'blur', 'input,textarea,select', function() {
					$( '.stick-me,.banner' ).removeClass( 'fixfixed' );
				} );
		}
	} );
}( jQuery ));
